<template>
  <modal :is-active="props.isActive" @close="close" :title="props.title" size="md">
    <template #body>
      <p>{{ $t('descriptions.select_new_booth_or_articles') }}</p>
      <div style="display: grid; grid-template-columns: 1fr 1fr;">
        <button class="btn btn-next btn-warning mr-2" @click="orderBooth">
          {{ $t('buttons.order_new_booth') }}
        </button>
        <button
          class="btn btn-next btn-warning ml-2"
          @click="orderArticles">
          {{ $t('buttons.order_new_articles') }}
        </button>
      </div>
      <div v-if="showBoothSelection">
        <p class="mt-3">{{ $t('descriptions.select_booth') }}</p>
        <div v-for="request in requestsWithBooth"
          :key="request.id"
          class="button-list">
          <button class="btn btn-next btn-warning btn-block" @click="orderArticlesForBooth(request)">
            <span>{{ (!inEnglish) ? request.booth.name : request.booth.name_en }}</span>
            <span>({{  $t(getBoothTypeName(request.booth_type)) }}</span>
            <span>,{{ $filters.formatLength(request.booth_width) }} x {{ $filters.formatLength(request.booth_depth) }} m)</span>
            <span v-if="request.booth_label.length > 0">, {{ request.booth_label }}</span>
          </button>
        </div>
      </div>
    </template>
  </modal>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useMainStore } from '@/store'

const store = useMainStore()
// define passed props
const props = defineProps({
  isActive: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    default: '',
  },
  user: {
    type: Object,
    default: {
      requests: [],
    }
  },
  boothTypes: {
    type: Array,
    default: []
  }
})
// define emits
const emit = defineEmits(['close', 'orderBooth', 'orderArticles'])
// define reactive props
const showBoothSelection = ref(false)
// define computed props
const locale = computed(() => store.settings.locale)

const inEnglish = computed(() => {
  return locale.value === 'en'
})

const hasMultipleRequest = computed(() => {
  return requestsWithBooth.value.length > 1
})

const requestsWithBooth = computed(() => {
  return props.user.requests.filter((request) => request.booth_id !== null)
})
// define methods

const close = () => {
  emit('close')
}

const orderBooth = () => {
  emit('orderBooth', props.user.requests[props.user.requests.length - 1])
}

const orderArticles = () => {
  if (hasMultipleRequest.value) {
    showBoothSelection.value = true
  } else {
    emit('orderArticles', props.user.requests[0])
  }
}

const orderArticlesForBooth = (request) => {
  emit('orderArticles', request)
}

const getBoothTypeName = (boothType) => {
  const boothIndex = props.boothTypes.findIndex((type) => type.type === boothType)
  if (boothIndex > -1) {
    return props.boothTypes[boothIndex].translation_key
  }

  return type
}
</script>

<style lang="scss" scoped>
.button-list {
  margin-top: 8px;

  &:first-child {
    margin-top: 0px;
  }
}
</style>